/* Product gallery — thumbnail switches the main image.

   The full-size images are large (~500KB), so a naive `main.src = full` on
   click means a cold network fetch every time and the main image goes blank
   while it downloads. Two things avoid that: the full-size URLs are warmed
   ahead of the click (on hover/focus, plus an idle pass over the rest), and
   the swap waits until the new image has decoded so the outgoing image stays
   on screen instead of flashing empty. */
(function () {
  'use strict';
  var gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;
  var main = gallery.querySelector('[data-gallery-main]');
  var label = gallery.querySelector('[data-gallery-label]');
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
  if (!main || !thumbs.length) return;

  var warmed = {};
  function warm(full) {
    if (!full || warmed[full]) return warmed[full];
    var img = new Image();
    img.src = full;
    warmed[full] = img;
    return img;
  }

  function show(full) {
    // main carries a srcset for responsive loading; browsers prefer srcset over
    // a plain .src assignment, so both it and sizes must go for the swap to take.
    var apply = function () {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = full;
    };
    var pre = warm(full);
    if (pre.complete) return apply();
    if (pre.decode) return pre.decode().then(apply, apply);
    pre.addEventListener('load', apply);
    pre.addEventListener('error', apply);
  }

  thumbs.forEach(function (thumb) {
    var full = thumb.getAttribute('data-full');

    // Warm the image the moment it looks like a click is coming.
    ['mouseenter', 'focus', 'touchstart'].forEach(function (evt) {
      thumb.addEventListener(evt, function () { warm(full); }, { passive: true });
    });

    thumb.addEventListener('click', function () {
      if (full) show(full);
      var lbl = thumb.getAttribute('data-label');
      if (label && lbl) label.textContent = lbl;
      thumbs.forEach(function (t) { t.style.borderColor = 'transparent'; });
      thumb.style.borderColor = 'var(--c-ink)';
    });
  });

  /* Warm the first few full-size images once the page is idle, one at a time so
     they never compete with the initial render for bandwidth. Capped because each
     is ~500KB: warming every thumbnail would mean megabytes the visitor may never
     look at. Hover/focus above covers the rest on demand. */
  var WARM_AHEAD = 3;

  function connectionIsCheap() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return true;
    if (c.saveData) return false;
    return !/(^|-)(2g|slow-2g)$/.test(c.effectiveType || '');
  }

  function warmAhead(i, budget) {
    if (i >= thumbs.length || budget <= 0) return;
    var full = thumbs[i].getAttribute('data-full');
    if (!full || warmed[full]) return warmAhead(i + 1, budget);
    var img = warm(full);
    var next = function () { warmAhead(i + 1, budget - 1); };
    if (img.complete) return next();
    img.addEventListener('load', next);
    img.addEventListener('error', next);
  }

  if (connectionIsCheap()) {
    var startWarming = function () { warmAhead(0, WARM_AHEAD); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(startWarming, { timeout: 4000 });
    } else {
      setTimeout(startWarming, 1500);
    }
  }
})();
